import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';

import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { createBrowserHistory } from 'history';

import { siteSettingsModel } from 'models/SiteSettingsModel';
import { versionModel } from 'models/VersionModel';
import { consoleVersions } from 'utils/consoleVersions';
import config from 'config/Config';

import packageInfo from '../package.json';

import App from './App';

const history = createBrowserHistory();

// process.env.NODE_ENV defaults to production on hosted environments
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://6d0b8e4f165cc90637aae1eee090193c@o992074.ingest.sentry.io/4506789742313472',
    integrations: [
      Sentry.reactRouterV5BrowserTracingIntegration({
        history,
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    release: packageInfo.version,
    environment: config.app_env,
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

siteSettingsModel
  .getMaintenanceMode()
  .then(({ maintenance }) => {
    versionModel
      .getVersionBE()
      .then(versionBE => consoleVersions({ versionFE: packageInfo.version, versionBE }))
      .catch(() => consoleVersions({ versionFE: packageInfo.version, versionBE: '' }));

    ReactDOM.render(<App maintenance={!!maintenance} />, document.getElementById('root'));
  })
  /* eslint-disable */
  .catch(error => console.error(error));
